module.exports = __webpack_public_path__ + "static/img/flower-petals_256.737cf41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flower-petals_256.png
// module id = 6HRs
// module chunks = 0